import { Directive, HostBinding, ElementRef, NgZone, InjectionToken, ReflectiveInjector } from '@angular/core';

@Directive({
  selector: '[tabInkBar]'
})
export class TabInkBarDirective {
  @HostBinding('class')
  bindingClass = 'tab-ink-bar';

  constructor(
    private _elementRef: ElementRef,
    private _ngZone: NgZone
  ) { }

  alignToElement(element: HTMLElement) {
    this.show();
    if (typeof requestAnimationFrame !== 'undefined') {
      this._ngZone.runOutsideAngular(() => {
        requestAnimationFrame(() => this.setStyles(element));
      });
    } else {
      this.setStyles(element);
    }
  }

  show(): void {
    this._elementRef.nativeElement.style.visibility = 'visible';
  }

  hide(): void {
    this._elementRef.nativeElement.style.visibility = 'hidden';
  }

  private setStyles(element: HTMLElement) {
    const position = this.getPosition(element);
    const inkBar: HTMLElement = this._elementRef.nativeElement;

    inkBar.style.left = position.left;
    inkBar.style.width = position.width;
  }

  private getPosition(element: HTMLElement) {
    if (!element) {
      return {
        left: '0',
        width: '0'
      };
    }
    return {
      left: element.offsetLeft + 'px',
      width: element.offsetWidth + 'px'
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/tab-ink-bar.directive.ts